const loadUserData = (commit, dataForStore) => {
  commit('LOAD_USER_NAME', dataForStore.userName)
  commit('LOAD_COMPANY_NAME', dataForStore.companyName)
  commit('LOAD_AUTH_TOKEN', dataForStore.authToken)
  commit('LOAD_SIGNED_IN', dataForStore.signedIn)
  localStorage.setItem('token', dataForStore.authToken)
}

const state = {
  userName: 'not logged in',
  authToken: null,
  companyName: 'Default Farm',
  signedIn: false,
  emailAddress: 'not available'
}

const mutations = {
  LOAD_USER_NAME (state, payload) {
    state.userName = payload
  },
  LOAD_COMPANY_NAME (state, payload) {
    state.companyName = payload
  },
  LOAD_AUTH_TOKEN (state, payload) {
    state.authToken = payload
  },
  LOAD_SIGNED_IN (state, payload) {
    state.signedIn = payload
  },
  LOAD_EMAIL_ADDRESS (state, payload) {
    state.emailAddress = payload
  }
}

const actions = {
  updateSession ({ commit }, dataForStore) {
    loadUserData(commit, dataForStore)
  },

  updateDefaultSession ({ commit }) {
    // set the user to the defaults
    // in other words, a user that is not signed in
    const dataForStore = {
      userName: 'not logged in',
      companyName: 'Default Farm',
      signedIn: false,
      authToken: ''
    }
    loadUserData(commit, dataForStore)
  },

  updateUserSignupData ({ commit }, userSignupData) {
    // this is for the signup form
    // it's good to store the data that they used when they
    // signed up in
    commit('LOAD_USER_NAME', userSignupData.userName)
    commit('LOAD_EMAIL_ADDRESS', userSignupData.emailAddress)
    commit('LOAD_COMPANY_NAME', userSignupData.companyName)
  },

  loadEmailAddress ({ commit }, emailAddress) {
    commit('LOAD_EMAIL_ADDRESS', emailAddress)
  }
}

const getters = {
  companyName: state => state.companyName,

  userName: state => state.userName,

  authToken: state => state.authToken,

  signedIn: state => state.signedIn,

  emailAddress: state => state.emailAddress
}

const userModule = {
  state,
  mutations,
  actions,
  getters
}

export default userModule
